/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- SENTIMENT ADVANCED SETTINGS - ADVANCED CONFIGS : STYLES --------------- ++++++++++ */
export default {
    sentimentadvancedsettings: {
        '& .message': {
            marginTop: pxToEm(20),
            marginBottom: pxToEm(30)
        }
    }
};
